<template>
  <div :class="['footer', isFixed]">
    <div class="by">
      <a href="https://twitter.com/usbclub" target="_blank">Twitter</a>
      <a href="https://www.instagram.com/bringyourusb" target="_blank"
        >Instagram</a
      >
      <transition name="nav-fade" mode="out-in">
        <component :is="footerComponent"></component>
      </transition>
    </div>
  </div>
</template>

<script>
import FooterToHome from "./FooterToHome.vue";
import FooterToCareering from "./FooterToCareering.vue";
import FooterToRoles from "./FooterToRoles.vue";

export default {
  name: "Footer",
  components: {
    FooterToHome,
    FooterToCareering,
    FooterToRoles,
  },
  props: {
    fixed: {
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isFixed() {
      return this.fixed ? "footer--is-fixed" : "";
    },
    footerComponent() {
      // show to home if we're in careering and not in role
      // show to careering if we're not in role or in careering
      if (this.inCareering && !this.inRole) {
        return "FooterToHome";
      } else if (this.inHomeATM) {
        return "FooterToCareering";
      } else if (!this.inCareering && !this.inRole) {
        return "FooterToCareering";
      } else if (this.inRole) {
        return "FooterToRoles";
      }

      return null;
    },
    inCareering() {
      return this.$route.path.includes("/careering") ? true : false;
    },
    inHomeATM() {
      return this.$route.path.includes("/atm") ? true : false;
    },
    inRole() {
      // Split the current route into segments
      const pathSegments = this.$route.path.split("/");
      // Check if the first segment is 'careering' and there is a second segment
      if (pathSegments.length > 2) {
        return pathSegments[1] === "careering" && pathSegments[2] !== "";
      }
      return false;
    },
  },
  watch: {},
  methods: {
    transitionTo(path) {
      this.$router.push(path);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.footer {
  width: 100%;
  color: var(--color-background);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(0deg, var(--color-background) 80%, transparent 100%);
}

.footer.footer--is-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
}

.by {
  color: #DDEDFF;
  padding: 20px;
  font-family: "ISO", monospace;
  font-size: 14px;
  letter-spacing: 0.2px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  grid-gap: 20px;
  width: 100%;
}

.by a,
.by a:visited {
  text-decoration: none;
  color: #DDEDFF;
  transition: all 350ms ease-in-out;
}

.by a:hover {
  color: white;
  text-decoration: none;
}

.nav-fade-enter-from,
.nav-fade-leave-to {
  opacity: 0;
  transform: scale(0);
  transform-origin: center center;
}

.nav-fade-enter-to,
.nav-fade-leave-from {
  opacity: 1;
  transform: scale(1);
}

.nav-fade-enter-active,
.nav-fade-leave-active {
  transition: all 350ms ease-in-out;
}
</style>
